import React, { createContext, useState } from "react";

export const AppProvider = (props) => {
  const { Provider } = AppContext;
  const [fun, setFun] = useState({
    onSavePdf: "",
    plcHldrFun: "",
    newPlaceHolder: "",
  });

  return <Provider value={[fun, setFun]}>{props.children}</Provider>;
};

export const AppContext = createContext();
